const CreditsText = () => {
    return (
        <>Hecho con ♥ por Five Digital Minds - 2026 | v5.2.22</>
    )
}

export { CreditsText };